var map = {
	"app/components/admin/admin.module": [
		"./src/app/components/admin/admin.module.ts",
		"admin.module",
		"common"
	],
	"app/components/home/home.module": [
		"./src/app/components/home/home.module.ts",
		"home.module",
		"common"
	],
	"app/components/login/login.module": [
		"./src/app/components/login/login.module.ts",
		"login.module"
	],
	"app/components/recover-password/recover-password.module": [
		"./src/app/components/recover-password/recover-password.module.ts",
		"recover-password.module"
	],
	"app/components/reset-password/reset-password.module": [
		"./src/app/components/reset-password/reset-password.module.ts",
		"reset-password.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main